import React from 'react';
import { useNavigate as useNavigateRouter } from 'react-router-dom';

const VendorDetails = ({
                           description,
                           address,
                           googleMapsUrl,
                           formattedAddress,
                           workingHoursFormatted,
                           email,
                           phone_number,
                           formatPhoneNumber,
                           additional_phones = [],
                           web_site,
                           social_media = [],
                           showSharePopup,
                           vendorName,
                           shareSpecializations = [],
                           isOwner,
                           onOpenRequestForm,
                           isAuthenticated,
                           shouldShowClaimButton,
                           onClaimProfileClick,
                           vendorId,
                           showPhoneNumber,
                       }) => {

    const navigate = useNavigateRouter();

    return (
        <div className="profile__content userdata">
            <div className="col-2">
                <div className="data">
                    <p>{description || "No description available."}</p>
                </div>
                <div className="profile__contacts">
                    <ul className="contacts">
                        {address && address.street_address && (
                            <li className="contacts__el">
                                <div className="contacts__label">Address</div>
                                <div className="contacts__value">
                                    <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">{formattedAddress}</a>
                                </div>
                            </li>
                        )}
                        {workingHoursFormatted && workingHoursFormatted.length > 0 && workingHoursFormatted[0] !== "Working hours not specified." && (
                            <li className="contacts__el">
                                <div className="contacts__label">Working Hours</div>
                                <div className="contacts__value">
                                    <ul className="hours">
                                        {workingHoursFormatted.map((item, index) => {
                                            const parts = item.split(': ');
                                            const dayPart = parts[0];
                                            const timePart = parts.length > 1 ? parts.slice(1).join(': ') : 'N/A';
                                            return ( <li key={index}><span className="working-hours__day">{dayPart}:</span> <span className="working-hours__time">{timePart}</span></li> );
                                        })}
                                    </ul>
                                </div>
                            </li>
                        )}

                        {phone_number && phone_number !== "N/A" && (
                            <li className="contacts__el">
                                <div className="contacts__label">Phone</div>
                                <div className="contacts__value">
                                    {showPhoneNumber ? (
                                        <a href={`tel:${phone_number}`}>{formatPhoneNumber(phone_number)}</a>
                                    ) : (
                                        <button
                                            onClick={onOpenRequestForm}
                                            type='button'
                                            className='button button-black button-send-message'
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            Request Service
                                        </button>
                                    )}
                                </div>
                            </li>
                        )}

                        {isOwner && additional_phones && additional_phones.length > 0 && (
                            additional_phones.map((phone, index) => (
                                <li key={phone.id || `add-phone-${index}`} className="contacts__el">
                                    <div className="contacts__label">{phone.phone_type?.name || 'Additional Phone'}</div>
                                    <div className="contacts__value">
                                        <a href={`tel:${phone.phone_number}`}>{formatPhoneNumber(phone.phone_number)}</a>
                                    </div>
                                </li>
                            ))
                        )}

                        {/* --- НАЧАЛО: ИСПРАВЛЕННЫЙ БЛОК КНОПКИ "CLAIM THIS PROFILE" --- */}
                        {shouldShowClaimButton && (
                            <li className="contacts__el">
                               <div className="contacts__label">Claim Profile</div>
                               <div className="contacts__value contacts__value--buttons">
                                   {isAuthenticated ? (
                                       // Для авторизованных пользователей
                                       <button
                                           onClick={onClaimProfileClick}
                                           type='button'
                                           className='button button-black'
                                       >
                                           Claim This Profile
                                       </button>
                                   ) : (
                                       // Для неавторизованных пользователей
                                       <button
                                           onClick={() => navigate(`/signup?claimVendorId=${vendorId}`)}
                                           type='button'
                                           className='button button-black'
                                       >
                                           Sign Up & Claim
                                       </button>
                                   )}
                               </div>
                            </li>
                        )}
                        {/* --- КОНЕЦ: ИСПРАВЛЕННЫЙ БЛОК КНОПКИ "CLAIM THIS PROFILE" --- */}

                        {web_site && (
                            <li className="contacts__el">
                                <div className="contacts__label">Web Site</div>
                                <div className="contacts__value">
                                    <a href={web_site.startsWith('http') ? web_site : `http://${web_site}`} target="_blank" rel="noopener noreferrer">{web_site}</a>
                                </div>
                            </li>
                        )}
                        {social_media && social_media.length > 0 && (
                            <li className="contacts__el">
                                <div className="contacts__label">Social Media</div>
                                <div className="contacts__value">
                                    <ul className="social">
                                        {social_media.map((sm, index) => (
                                            <li key={sm.id || `sm-${index}`}>
                                                <a href={sm.url} target="_blank" rel="noopener noreferrer" aria-label={sm.platform?.name}>
                                                    {sm.platform?.icon ? <img src={sm.platform.icon} alt={sm.platform.name}/> : sm.platform?.name}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        )}
                    </ul>

                    {typeof showSharePopup === 'function' && (
                         <button
                            onClick={() => showSharePopup({
                                companyName: vendorName,
                                telephone: phone_number,
                                address: formattedAddress,
                                specializations: shareSpecializations
                            })}
                            type='button'
                            className='profile__share button no-style'
                            style={{marginTop: '15px'}}
                        >
                            Share Profile
                            <img src="/assets/icon--share.svg" alt="Share Icon"/>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VendorDetails;